import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { $apiV2, errorHandler, globalConst, setUser } from 'modules/global';

import { IProfile } from '../models';

export const useRegister = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { replace } = useRouter();
  const redirectUrl = useAppSelector(({ authModal }) => authModal.redirectUrl);
  const ticketId = useAppSelector(({ authModal }) => authModal.ticketId);

  return useMutation({
    mutationFn: async (values: IProfile) => {
      const res = await $apiV2.post(`/auth/register`, values);

      return res.data;
    },
    onSuccess: async data => {
      await Promise.allSettled([queryClient.invalidateQueries({ queryKey: [globalConst.queryKeys.USER_DATA] })]);
      dispatch(setUser(data.user));
      message.success(t('royxatdan_muvaffaqiyatli_otdingiz'));
      if (redirectUrl) {
        return replace(redirectUrl);
      }

      if (ticketId) {
        return replace(`${globalConst.pageNames.RESULTS}/${ticketId}`);
      }
      return undefined;
    },
    onError: errorHandler()
  });
};
